import STATES from '../../core/us-states';
import memoize from '../fp/memoize';

/**
 * @public
 * Gets the state name from a state acronym.
 *
 * @param  {String} acronym: the state acronym
 * @return {String}
 */
const getStateName = memoize((acronym) => {
  acronym = acronym.trim().toUpperCase();
  const state = STATES.find(s => s.Abbr === acronym);
  if (!state) return '';
  return state.Name;
});

export default getStateName;
